const _ = [
  "beacon-accordion",
  "beacon-accordion-item",
  "beacon-anchor-navigation",
  "beacon-area-chart",
  "beacon-article-tile",
  "beacon-bar-chart",
  "beacon-bio-card",
  "beacon-button",
  "beacon-byline",
  "beacon-carousel",
  "beacon-chart-tooltip",
  "beacon-chart-tooltip-data",
  "beacon-checkbox",
  "beacon-collection-tile",
  "beacon-contact-tile",
  "beacon-control",
  "beacon-control-group",
  "beacon-country",
  "beacon-country-selector",
  "beacon-data-list",
  "beacon-date-picker",
  "beacon-donut-chart",
  "beacon-dropdown",
  "beacon-error",
  "beacon-error-message-summary",
  "beacon-footer",
  "beacon-gauge-chart",
  "beacon-hero",
  "beacon-icon-button",
  "beacon-id-card",
  "beacon-input-button-field",
  "beacon-input-field",
  "beacon-key-facts",
  "beacon-legacy-collection-tile",
  "beacon-legend",
  "beacon-legend-item",
  "beacon-line-chart",
  "beacon-modal",
  "beacon-navigation",
  "beacon-navigation-button",
  "beacon-navigation-expanded",
  "beacon-navigation-footer",
  "beacon-navigation-popover",
  "beacon-navigation-toolbelt",
  "beacon-notification",
  "beacon-notification-group",
  "beacon-popover",
  "beacon-promo-tile",
  "beacon-quote-block",
  "beacon-radio-button",
  "beacon-radio-group",
  "beacon-region-selector",
  "beacon-scatter-chart",
  "beacon-segmented-control",
  "beacon-segmented-controls",
  "beacon-social-link",
  "beacon-social-link-container",
  "beacon-stepper",
  "beacon-tab",
  "beacon-tab-panel",
  "beacon-table",
  "beacon-table-caption",
  "beacon-table-header",
  "beacon-table-record",
  "beacon-table-stub",
  "beacon-tabs",
  "beacon-text-area",
  "beacon-toggle-button-field",
  "beacon-tooltip",
  "beacon-value-prop",
  "beacon-video",
  "beacon-video-tag",
  "beacon-video-transcript"
], x = {
  allComponents: _
}, g = (t) => t.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (e, n) => (n ? "-" : "") + e.toLowerCase()), j = (t) => /^([a-z](?![\d])|[\d](?![a-z]))+(-?([a-z](?![\d])|[\d](?![a-z])))*$|^$/.test(t);
function h(t) {
  return `${t}`.toLowerCase().replace(new RegExp(/[-_]+/, "g"), " ").replace(new RegExp(/[^\w\s]/, "g"), "").replace(new RegExp(/\s+(.)(\w*)/, "g"), (e, n, a) => `${n.toUpperCase() + a}`).replace(new RegExp(/\w/), (e) => e.toUpperCase());
}
const f = typeof process == "object" && process && process.env && process.env.UNIT_TESTING_ENV;
function v(t) {
  switch (t) {
    case "./__temp-separated/beacon-accordion/index.js":
      return import("./register-chunks/index-CdtboMyS.js");
    case "./__temp-separated/beacon-accordion-item/index.js":
      return import("./register-chunks/index-Bi1eAPC1.js");
    case "./__temp-separated/beacon-anchor-navigation/index.js":
      return import("./register-chunks/index-o4KD2BUM.js");
    case "./__temp-separated/beacon-area-chart/index.js":
      return import("./register-chunks/index-CqntVueu.js");
    case "./__temp-separated/beacon-article-tile/index.js":
      return import("./register-chunks/index-DoPO6WWa.js");
    case "./__temp-separated/beacon-bar-chart/index.js":
      return import("./register-chunks/index-CvyfP3Ll.js");
    case "./__temp-separated/beacon-bio-card/index.js":
      return import("./register-chunks/index-DGfqkDW7.js");
    case "./__temp-separated/beacon-button/index.js":
      return import("./register-chunks/index-D97CBP89.js");
    case "./__temp-separated/beacon-byline/index.js":
      return import("./register-chunks/index-QhboJ0Z0.js");
    case "./__temp-separated/beacon-carousel/index.js":
      return import("./register-chunks/index-DzIb-ptt.js");
    case "./__temp-separated/beacon-chart-tooltip/index.js":
      return import("./register-chunks/index-YypW8LQs.js");
    case "./__temp-separated/beacon-chart-tooltip-data/index.js":
      return import("./register-chunks/index-BBLs_gf5.js");
    case "./__temp-separated/beacon-checkbox/index.js":
      return import("./register-chunks/index-8ONN3jIA.js");
    case "./__temp-separated/beacon-collection-tile/index.js":
      return import("./register-chunks/index-BNKNozK5.js");
    case "./__temp-separated/beacon-contact-tile/index.js":
      return import("./register-chunks/index-CSyKgMsV.js");
    case "./__temp-separated/beacon-control/index.js":
      return import("./register-chunks/index-UPji0rS8.js");
    case "./__temp-separated/beacon-control-group/index.js":
      return import("./register-chunks/index-DsVCk_Jr.js");
    case "./__temp-separated/beacon-country/index.js":
      return import("./register-chunks/index-BYkYOkaM.js");
    case "./__temp-separated/beacon-country-selector/index.js":
      return import("./register-chunks/index-C6yGrN8V.js");
    case "./__temp-separated/beacon-data-list/index.js":
      return import("./register-chunks/index-BoIY489G.js");
    case "./__temp-separated/beacon-date-picker/index.js":
      return import("./register-chunks/index-CaYPIAIy.js");
    case "./__temp-separated/beacon-donut-chart/index.js":
      return import("./register-chunks/index-ChYGk8Ef.js");
    case "./__temp-separated/beacon-dropdown/index.js":
      return import("./register-chunks/index--AX37ZUS.js");
    case "./__temp-separated/beacon-error/index.js":
      return import("./register-chunks/index-D4k3NSDM.js");
    case "./__temp-separated/beacon-error-message-summary/index.js":
      return import("./register-chunks/index-1vEh1fn9.js");
    case "./__temp-separated/beacon-footer/index.js":
      return import("./register-chunks/index-nWrv-RzT.js");
    case "./__temp-separated/beacon-gauge-chart/index.js":
      return import("./register-chunks/index-Dk6ID9jn.js");
    case "./__temp-separated/beacon-hero/index.js":
      return import("./register-chunks/index-QlDNiFvm.js");
    case "./__temp-separated/beacon-icon-button/index.js":
      return import("./register-chunks/index-DWfTIhgh.js");
    case "./__temp-separated/beacon-id-card/index.js":
      return import("./register-chunks/index-D-y4sRtj.js");
    case "./__temp-separated/beacon-index.test-components/index.js":
      return import("./register-chunks/index-D_aLSZdg.js");
    case "./__temp-separated/beacon-input-button-field/index.js":
      return import("./register-chunks/index-CONKIgUM.js");
    case "./__temp-separated/beacon-input-field/index.js":
      return import("./register-chunks/index-I174LUxG.js");
    case "./__temp-separated/beacon-key-facts/index.js":
      return import("./register-chunks/index-B17CMIiR.js");
    case "./__temp-separated/beacon-legacy-collection-tile/index.js":
      return import("./register-chunks/index-D6MG6BQs.js");
    case "./__temp-separated/beacon-legend/index.js":
      return import("./register-chunks/index-trp1KaYN.js");
    case "./__temp-separated/beacon-legend-item/index.js":
      return import("./register-chunks/index-hEb2fjSO.js");
    case "./__temp-separated/beacon-line-chart/index.js":
      return import("./register-chunks/index-B10v0ECL.js");
    case "./__temp-separated/beacon-modal/index.js":
      return import("./register-chunks/index-Cl7-kq0M.js");
    case "./__temp-separated/beacon-navigation/index.js":
      return import("./register-chunks/index-CdtC7swi.js").then((e) => e.index);
    case "./__temp-separated/beacon-navigation-button/index.js":
      return import("./register-chunks/index-CdtC7swi.js").then((e) => e.index$1);
    case "./__temp-separated/beacon-navigation-expanded/index.js":
      return import("./register-chunks/index-CdtC7swi.js").then((e) => e.index$2);
    case "./__temp-separated/beacon-navigation-footer/index.js":
      return import("./register-chunks/index-CS96ydnB.js");
    case "./__temp-separated/beacon-navigation-popover/index.js":
      return import("./register-chunks/index-CdtC7swi.js").then((e) => e.index$3);
    case "./__temp-separated/beacon-navigation-toolbelt/index.js":
      return import("./register-chunks/index-CdtC7swi.js").then((e) => e.index$4);
    case "./__temp-separated/beacon-notification/index.js":
      return import("./register-chunks/index-B3P9T3n0.js");
    case "./__temp-separated/beacon-notification-group/index.js":
      return import("./register-chunks/index-DpSAhbxs.js");
    case "./__temp-separated/beacon-popover/index.js":
      return import("./register-chunks/index-CZ_s6RnK.js");
    case "./__temp-separated/beacon-promo-tile/index.js":
      return import("./register-chunks/index-r2KAO9in.js");
    case "./__temp-separated/beacon-quote-block/index.js":
      return import("./register-chunks/index-B-lqtYmm.js");
    case "./__temp-separated/beacon-radio-button/index.js":
      return import("./register-chunks/index-DG0LOVRv.js");
    case "./__temp-separated/beacon-radio-group/index.js":
      return import("./register-chunks/index-DmUsKo8m.js");
    case "./__temp-separated/beacon-region-selector/index.js":
      return import("./register-chunks/index-BXGWHOYH.js");
    case "./__temp-separated/beacon-scatter-chart/index.js":
      return import("./register-chunks/index-CvAkc8bo.js");
    case "./__temp-separated/beacon-segmented-control/index.js":
      return import("./register-chunks/index-CK9XDRLy.js");
    case "./__temp-separated/beacon-segmented-controls/index.js":
      return import("./register-chunks/index-BqOrztae.js");
    case "./__temp-separated/beacon-social-link/index.js":
      return import("./register-chunks/index-ByBYfx1L.js");
    case "./__temp-separated/beacon-social-link-container/index.js":
      return import("./register-chunks/index-Dyu4qxtu.js");
    case "./__temp-separated/beacon-stepper/index.js":
      return import("./register-chunks/index-jDh_48CU.js");
    case "./__temp-separated/beacon-tab/index.js":
      return import("./register-chunks/index-BLgGsCgN.js");
    case "./__temp-separated/beacon-tab-panel/index.js":
      return import("./register-chunks/index-C67cyk3Q.js");
    case "./__temp-separated/beacon-table/index.js":
      return import("./register-chunks/index-BaZpr-Lt.js");
    case "./__temp-separated/beacon-table-caption/index.js":
      return import("./register-chunks/index-BL-6CRVJ.js");
    case "./__temp-separated/beacon-table-header/index.js":
      return import("./register-chunks/index-Di0Rh9g2.js").then((e) => e.index);
    case "./__temp-separated/beacon-table-record/index.js":
      return import("./register-chunks/index-C0gEdvLd.js").then((e) => e.index);
    case "./__temp-separated/beacon-table-stub/index.js":
      return import("./register-chunks/index-pGKW4zoA.js").then((e) => e.index);
    case "./__temp-separated/beacon-tabs/index.js":
      return import("./register-chunks/index-LYvCg9Sy.js");
    case "./__temp-separated/beacon-text-area/index.js":
      return import("./register-chunks/index-C9vkoidm.js");
    case "./__temp-separated/beacon-toggle-button-field/index.js":
      return import("./register-chunks/index-DqeZo0qp.js");
    case "./__temp-separated/beacon-tooltip/index.js":
      return import("./register-chunks/index-COc_e_cs.js");
    case "./__temp-separated/beacon-value-prop/index.js":
      return import("./register-chunks/index-Bq8dZt4c.js");
    case "./__temp-separated/beacon-video/index.js":
      return import("./register-chunks/index-DH90IXED.js");
    case "./__temp-separated/beacon-video-tag/index.js":
      return import("./register-chunks/index-D4xS61PM.js");
    case "./__temp-separated/beacon-video-transcript/index.js":
      return import("./register-chunks/index-DXJ7BmrB.js");
    default:
      return new Promise(function(e, n) {
        (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
          n.bind(null, new Error("Unknown variable dynamic import: " + t))
        );
      });
  }
}
const d = async (t = "", e = document.body) => {
  const n = t ? t + "-beacon-" : "beacon-", a = e instanceof Element ? e.tagName.toLowerCase() : "", o = a == null ? void 0 : a.startsWith(n), s = [...e.querySelectorAll(":not(:defined)")].map((c) => c.tagName.toLowerCase()).filter((c) => c.startsWith(n));
  o && !customElements.get(a) && s.push(a);
  const r = [...new Set(s)].map((c) => t ? c.split(`${t}-`)[1] : c);
  r.length && await y(t, r);
}, w = (t) => {
  const e = g(t);
  return j(t) || console.warn(
    `Beacon Warning: '${t}' is not a valid Beacon component tag name. Class name casing will be deprecated soon. Update to tag name "${e}".`
  ), e;
}, C = (t) => {
  const e = w(t);
  return {
    tagName: e,
    className: h(e)
  };
}, m = async (t, e, n) => new Promise((a, o) => {
  var s;
  if (typeof e == "string") {
    const { tagName: r, className: c } = C(e), b = t ? `${t}-${r}` : r;
    customElements.get(b) ? a(customElements.get(b)) : v(`./__temp-separated/${r}/index.js`).then((i) => {
      var l;
      const p = i[`${c}`];
      p.registerComponent(t), (l = p.nestedComponents) != null && l.length && Promise.all(
        p.nestedComponents.map(
          (u) => m(t, u, n)
        )
      ), a(p);
    }).catch(() => {
      const i = `Beacon Registration Error: Unable to import ${e}`;
      n ? o(new Error(i)) : a(i);
    });
  } else if (e.registerComponent) {
    const r = e;
    r.registerComponent(t), (s = r.nestedComponents) != null && s.length && Promise.all(
      r.nestedComponents.map(
        (c) => m(t, c, n)
      )
    ), a(r);
  }
}), y = async (t = "", e = [], n = !f) => {
  const a = e.length ? e : x.allComponents;
  await Promise.all(
    a.map(
      (o) => m(t, o, n)
    )
  );
}, $ = async (t = "") => {
  const e = new MutationObserver(async (n) => {
    for (const { addedNodes: a } of n)
      for (const o of a)
        o instanceof Element && await d(t, o);
  });
  return E(e), await d(t), k(t), e.observe(document.documentElement, { subtree: !0, childList: !0 }), e;
}, E = (t) => {
  const e = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function(n) {
    const a = e.call(this, n);
    return this.tagName.includes("BEACON") || t.observe(a, { subtree: !0, childList: !0 }), a;
  };
}, k = (t, e = document) => {
  Array.from(e.querySelectorAll(":not([beacon-tag-name])")).filter(
    (o) => o.tagName.includes("-") && !o.tagName.includes("BEACON")
  ).forEach((o) => {
    o.shadowRoot && o instanceof HTMLElement && d(t, o.shadowRoot);
  });
};
export {
  $ as autoLoadBeaconComponents,
  k as discoverComponentsInShadowDOM,
  C as getComponentIdentifiers,
  w as getComponentTagName,
  m as importAndRegisterComponent,
  E as polyfillAttachShadowWithObserver,
  y as registerBeaconComponents
};
